// TRE-2122: at sign-out (and when another account signs in), delete the service worker's runtime
// caches. Workers before TRE-2122 stored backend responses there, keyed by address alone, so the next
// person on the same computer could be served them. Only Trebble's runtime caches ("v<N>::<build>pages")
// are deleted; the precached app files ("…fundamentals") and caches owned by other code are kept.
//
// Best effort: the deletion keeps running in the background, but callers wait at most maxWaitMs, so
// sign-out never hangs on a slow or unavailable cache store.
//
// No imports: the service-worker browser test loads this file directly as a module.

const TREBBLE_RUNTIME_CACHE_NAME = /^v\d+::.+pages$/;
const DEFAULT_MAX_WAIT_MS = 1200;

function defaultCacheStorage() {
  try {
    return typeof caches !== "undefined" && caches ? caches : null;
  } catch (error) {
    // Reading CacheStorage throws a SecurityError when the browser denies storage access.
    return null;
  }
}

function deleteRuntimeCaches(cacheStorage) {
  return Promise.resolve()
    .then(function () {
      return cacheStorage.keys();
    })
    .then(function (cacheNames) {
      return Promise.all(
        cacheNames
          .filter(function (cacheName) {
            return TREBBLE_RUNTIME_CACHE_NAME.test(cacheName);
          })
          .map(function (cacheName) {
            return cacheStorage.delete(cacheName);
          }),
      );
    })
    .then(
      function () {
        return true;
      },
      function () {
        return false;
      },
    );
}

/**
 * Starts deleting Trebble's runtime caches. Resolves true once they are deleted, false if the cache
 * store failed or is unavailable, or undefined if maxWaitMs passed first. Every call starts its own
 * deletion (it is idempotent), so one that hangs never stops a later sign-out from cleaning. Never
 * throws and never rejects: sign-in and sign-out must carry on regardless.
 */
export function clearServiceWorkerRuntimeCaches(options) {
  try {
    const resolvedOptions = options || {};
    const cacheStorage = resolvedOptions.cacheStorage || defaultCacheStorage();
    if (!cacheStorage || typeof cacheStorage.keys !== "function") {
      return Promise.resolve(false);
    }
    const cleanup = deleteRuntimeCaches(cacheStorage);
    const maxWaitMs = typeof resolvedOptions.maxWaitMs === "number" ? resolvedOptions.maxWaitMs : DEFAULT_MAX_WAIT_MS;
    return Promise.race([
      cleanup,
      new Promise(function (resolve) {
        setTimeout(resolve, maxWaitMs);
      }),
    ]).catch(function () {
      return false;
    });
  } catch (error) {
    return Promise.resolve(false);
  }
}
